export const MAX_PRICE_CHANGE_PERCENTAGE = 50
